import { Form } from 'react-bootstrap';

type Props = {
  selectedValue?: string | null;
  defaultValue?: string | null;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
};

const ScheduleStatus = ({ selectedValue, defaultValue = 'open', onChange }: Props) => {
  const value = selectedValue ?? defaultValue ?? '';

  return (
    <Form.Group className="mb-2" controlId="formScheduleStatus">
      <Form.Label>Schedule Status</Form.Label>
      <Form.Select aria-label="schedule-status-select" name="schedule_status" value={value} onChange={onChange}>
        <option value="open">Open</option>
        <option value="closed">Closed</option>
      </Form.Select>
    </Form.Group>
  );
};

export default ScheduleStatus;
